const GeneralContent = (props) => {
  const { carrot } = props;

  if (!carrot.content || carrot.content.length === 0) {
    return null;
  }

  return (
    <div className="c7-carrot">
      <div
        className="c7-carrot__message"
        dangerouslySetInnerHTML={{ __html: carrot.content }}
      />
    </div>
  );
};

export default GeneralContent;
